import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { useParams, useNavigate } from 'react-router-dom';
import {
    Box,
    Button,
    Container,
    Divider,
    Grid,
    Typography,
    CircularProgress
} from '@mui/material';
import HeaderComponent from '../../common/HeaderComponent/HeaderComponent';
import { setorderBookingDetails, getBookdetails } from '../../store/actions/book.js';
import * as config from "../../assets/js/constant.js";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const BookDescriptionComponent = ({
    getBookdetails,
    bookDetails,
    setorderBookingDetails,
    bookOrderDetails
}) => {
    const navigate = useNavigate();
    const { BookID } = useParams();
    const [isFetching, setIsFetching] = useState(true);

    // --- 1. DATA FETCHING ---
    useEffect(() => {
        if (BookID) {
            setIsFetching(true);
            getBookdetails(BookID);
        }
    }, [BookID, getBookdetails]);

    // --- 2. VALIDATION & LOADER CONTROL ---
    useEffect(() => {
        if (!bookDetails) return;

        // Normalize both to Numbers to handle '0115' vs '115'
        const urlId = Number(BookID);
        const reduxId = bookDetails.BookID ? Number(bookDetails.BookID) : null;

        // SUCCESS: If numeric values match, data is correct
        if (reduxId === urlId && !isNaN(urlId)) {
            setIsFetching(false);
        }
        // ERROR: If API returns empty object (Invalid ID)
        else if (bookDetails && Object.keys(bookDetails).length === 0) {
            const timer = setTimeout(() => {
                if (Object.keys(bookDetails).length === 0) {
                    navigate("/get-books");
                }
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [bookDetails, BookID, navigate]);

    // --- 3. CART HANDLERS ---
    // Use Number() for comparison here too
    const isCorrectBookLoaded = bookDetails?.BookID && Number(bookDetails.BookID) === Number(BookID);

    const currentBookOrder = isCorrectBookLoaded
        ? bookOrderDetails.find(order => Number(order.BookID) === Number(bookDetails.BookID))
        : null;

    const currentCount = currentBookOrder ? currentBookOrder.Copy : 0;

    const handleIncrement = () => {
        setorderBookingDetails({ ...bookDetails, increment: true });
    };

    const handleDecrement = () => {
        setorderBookingDetails({ ...bookDetails, decrement: true });
    };

    // --- 4. RENDER LOGIC ---
    // Update comparison to use Number()
    const isMismatch = bookDetails?.BookID && Number(bookDetails.BookID) !== Number(BookID);

    if (isFetching || isMismatch) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <>
            <HeaderComponent />
            <Container>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pt: 2 }}>
                    <Typography sx={{ backgroundColor: '#686868', padding: '6px 12px', borderRadius: '40px', color: '#ffffff' }}>
                        Book Description
                    </Typography>
                    <Button
                        variant="outlined"
                        sx={{ borderRadius: '50px', color: '#010101', borderColor: '#D9D9D9' }}
                        onClick={() => navigate("/get-books")}
                    >
                        Back
                    </Button>
                </Box>
            </Container>

            <Box sx={{ mt: 3 }}>
                <Container>
                    <Grid container spacing={1} sx={{ mb: 2 }}>
                        <Grid item xs={12} md={4}>
                            <Box className="user-selected-book" sx={{ textAlign: 'center', border: '1px solid #eee', p: 1 }}>
                                <img
                                    className='book-image'
                                    src={config.image + (bookDetails.Image || '')}
                                    alt={bookDetails.BookName}
                                    style={{ maxWidth: '100%', borderRadius: '4px' }}
                                />
                                <Typography
                                    className="donation-btn"
                                    sx={{ border: '1px solid #3875BF', borderRadius: '40px', textTransform: 'capitalize', mb: 0, color: '#3875BF', fontWeight: '500', padding: '6px 8px' }}
                                >
                                    Suggested Donation | ₹{bookDetails.Amount}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <Box className="book-description">
                                <Typography sx={{ fontSize: '20px', fontWeight: '600', color: '#3875BF', mb: 2 }}>
                                    {bookDetails.BookName}
                                </Typography>
                                <Typography sx={{ whiteSpace: 'pre-line', lineHeight: 2.3, color: '#8E8E8E' }}>
                                    {bookDetails.Description}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    <Box sx={{ textAlign: 'center', my: 4 }}>
                        {currentCount > 0 ? (
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Button onClick={handleDecrement} sx={{ minWidth: '40px' }}><RemoveIcon fontSize="small" /></Button>
                                <Typography sx={{ mx: 2, fontWeight: 'bold' }}>{currentCount}</Typography>
                                <Button onClick={handleIncrement} sx={{ minWidth: '40px' }}><AddIcon fontSize="small" /></Button>
                            </Box>
                        ) : (
                            <Button
                                onClick={handleIncrement}
                                variant="contained"
                                sx={{ borderRadius: '40px', px: 6, py: 1, backgroundColor: '#3875BF' }}
                            >
                                ADD
                            </Button>
                        )}
                    </Box>
                    <Divider />
                </Container>
            </Box>
        </>
    );
}

const mapStateToProps = (state) => ({
    bookDetails: state.book.bookDetails,
    bookOrderDetails: state.book.bookOrderDetails
});

export default connect(mapStateToProps, { getBookdetails, setorderBookingDetails })(BookDescriptionComponent);